import { render, staticRenderFns } from "./SpecifyReason.vue?vue&type=template&id=29cfc394&scoped=true&"
import script from "./SpecifyReason.vue?vue&type=script&lang=js&"
export * from "./SpecifyReason.vue?vue&type=script&lang=js&"
import style0 from "./SpecifyReason.vue?vue&type=style&index=0&id=29cfc394&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cfc394",
  null
  
)

export default component.exports